import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Avatar, Switch, Row, Col, Tag, Tooltip } from "antd";
import { MoreOutlined, PhoneOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import "./LeadCard.css";
import * as actions from "../../store/actions/index";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { drop } from "lodash";
import AllocateModal from "../Tab/Allocate";

import { updateCheckAllocatedLead } from "../../store/actions/leads";

const LeadCard = React.memo((props) => {
  const dispatch = useDispatch();
  const allocateBtnStatus = useSelector((state) => state?.leads?.allocateTab);
  const checkedLead = useSelector((state) => state?.leads?.checkedLead);
  const unCheckedLead = useSelector((state) => state?.leads?.unCheckedLead);
  const LeadData = useSelector((state) => state?.newLead?.payloadFormData);

  const history = useHistory();
  const {
    id,
    lead_Id,
    leadStatus,
    // firstName,
    // lastName,
    leadName,
    leadType,

    created_date,
    allocatedDate,
    primaryMobile,
    allocatedBy,
    allocatedTo,
    opportunity_Id,
    leadPolicyId,
    appointmentOn,
    lsq,
    lsqSource,
    isProposalCreated,
    sourceOfLead,
  } = props;
  // console.warn('PROPSSSS___________',props)
  const leadsData = useSelector((state) => state.leads);
  const [chkID, setChkId] = useState("");

  function checkboxes(data, e) {
    e.target.checked ? dispatch(updateCheckAllocatedLead([...checkedLead, data])) : dispatch(updateCheckAllocatedLead(checkedLead?.filter((a) => a.id !== data.id) || []));
    setChkId(data.Id);
  }

  useEffect(() => {
    !checkedLead.length && setChkId("");
  }, [checkedLead]);

  const leadComponent =
    leadStatus === "Converted" ? (
      <p className="user-status-text capitalize converted">{leadStatus}</p>
    ) : leadStatus === "Failed" ? (
      <p className="user-status-text capitalize failed">{leadStatus}</p>
    ) : leadStatus === "Closed" ? (
      <p className="user-status-text capitalize" style={{ color: "#D04949" }}>
        {leadStatus}
      </p>
    ) : (
      <p className="user-status-text capitalize open">{leadStatus}</p>
    );

  // let avatar = leadName

  const [width, setWidth] = useState(window.innerWidth);
  const breakpoint = 620;

  useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleWindowResize);

    // Return a function from the effect that removes the event listener
    return () => window.removeEventListener("resize", handleWindowResize);
  }, [width]);
  const updateHandler = (id) => {
    //console.log("____LEADDDD___IDDD", id);
    // dispatch(actions.fetchLeadDetails(id));
    // let _data = actions.fetchLeadDetails(id);
    // //console.log('_data___LEADDDD',_data)
    // //console.log('history-----------',history)
    // LeadData._id === id && history.push("/leadmasterpage/statuslead");
    dispatch({ data: id, type: "CURRENT_UPDATING_ID" });
    localStorage.setItem("Current_Updating_Lead", id);
    history.push("/leadmasterpage/statuslead", { leadID: id });
  };
  let statusColors = {
    closed: "#D04949",
    open: "#e0cb0d",
    PendingProposals: "#b50e21",
    Converted: "#159e0e",
    statusStyle: "",
    bgColor: "",
  };
  const nameShorter = (str) => {
    try {
      if (str !== "") {
        str = str.toUpperCase();
        let arr = str.split(" ");
        let fLatter = arr[0].charAt(0);
        let sLatter = arr[1].charAt(0);
        // fLatter = fLatter.charAt(0);
        // sLatter = sLatter.charAt(0);
        str = fLatter + sLatter;
      }
      return str;
    } catch (error) {
      //console.log(error);
    }
  };

  const getRandomColor = () => {
    var letters = "0123456789ABCDEF";
    var color = "#";
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };
  // Card for desktop
  // console.log('SOURCE OF LEAD IN LEAD CARD----->',sourceOfLead);

  let card = (
    <div className="LeadCard-Main-Page-Container">
      <Card key={id} loading={props.loading} className="lead-card-desktop" hoverable={true}>
        {allocateBtnStatus && <input id="checkbox" type="checkbox" checked={chkID && checkedLead.length && checkedLead?.filter((a) => a.id.includes(chkID))} onChange={(e) => checkboxes(props, e)}></input>}

        <div className="main-avtar">
          <div className="avatar-and-status">
            <Avatar
              style={{
                paddingTop: "-40px",
                lineHeight: "none",
                backgroundColor: getRandomColor(),
              }}
              size={{ xl: 50 }}
            >
              {nameShorter(leadName)}
            </Avatar>

            {/* <div style={{ display: 'flex' }}>{leadStatus === "newleadentery" ? <div style={{ fontSize: '10px' }}>NEW<div>LEADENTRY</div></div> : leadStatus}</div> */}
            {leadComponent}
          </div>
          {/* <Avatar style={{paddingTop:'-40px',lineHeight:'none' }} size={{ xl: 50 }}>
            {avatar}
          </Avatar> */}
          {/* <div style={{display:'flex'}}>{leadStatus === "newleadentery"? <div style={{fontSize:'10px'}}>NEW<div>LEADENTRY</div></div> : leadStatus}</div> */}
          {/* <p className="user-status-text">{leadStatus === "newleadentery" || leadStatus === "contact" ? 'Open' : leadStatus}</p> */}
          {/* {leadComponent} */}
        </div>
        <div className="content">
          <div className="content-header1">
            <div className="avtar-data">
              <div className="otp-data">
                <p className="user-name-text capitalize">{leadName}</p>
                <span className="user-id user-name-text uppercase">{lead_Id}</span>

                <a href={`tel:${primaryMobile}`}></a>
                {/* <PhoneOutlined className="phoneicon"></PhoneOutlined> */}
              </div>
              <div className="otp-data">
                {/* <p className="user-name-text capitalize">OTP - <span style={{color: '#13bb13'}}>Verified</span></p> */}
                {/* {leadType ? <p className="capitalize bussiness">{leadType}</p> : ''} */}
                <p className="capitalize bussiness">{leadType}</p>
                {sourceOfLead === "DSO" ?
                  <p className="capitalize bussiness-lsq">{sourceOfLead}</p>
                  : lsq == "LSQ" ?
                    <p className="capitalize bussiness-lsq">{lsq}</p> :
                    <p className="capitalize bussiness-lsq">{lsq}</p>
                }
                {/* {leadType} */}
              </div>
            </div>
          </div>

          <hr
            style={{
              margin: "8px 0",
              opacity: "0.5",
              color: "lightgray",
            }}
          />

          <div className="content-body Datainfo-Main-Container">
            <div className="Dateinfo-Container">
              <Card.Grid hoverable={false} className="grid-style">
                <p className="text-type">Created on</p>
                <p className="text-content">{created_date}</p>
              </Card.Grid>
              <Card.Grid hoverable={false} className="grid-style AllocatedBy-Heading">
                <p className="text-type">Allocated on</p>
                <p className="text-content">{allocatedDate}</p>
              </Card.Grid>
              <Card.Grid hoverable={false} className="grid-style Appoinment-Heading">
                {lsq == "LSQ" ? (
                  <>
                    <p className="text-type">Sub Source</p>
                    <p className="text-content">{lsqSource}</p>
                  </>
                ) : null}
              </Card.Grid>
              <Card.Grid hoverable={false} className="grid-style">
                <p className="text-type">Mobile No.</p>
                <p className="text-content">{primaryMobile}</p>
              </Card.Grid>
              <Card.Grid hoverable={false} className="grid-style AllocatedBy-Heading">
                <p className="text-type">Allocated by</p>
                <p className="text-content capitalize" style={{ width: "100px" }}>
                  {allocatedBy}
                </p>
              </Card.Grid>
              <Card.Grid hoverable={false} className="grid-style Appoinment-Heading">
                <p className="text-type">Allocated to</p>
                <p className="text-content capitalize" style={{ width: "100px" }}>
                  {allocatedTo}
                </p>
              </Card.Grid>
              <Card.Grid hoverable={false} className="grid-style Appoinment-Heading">
                <p className="text-type">Opportunity Id</p>
                <p className="text-content capitalize" style={{ width: "100px" }}>
                  {opportunity_Id && opportunity_Id !== "-" ? (
                    <>
                      <Tooltip title={`${opportunity_Id}`}
                      >
                        <span>
                          ...{opportunity_Id.slice(-5)} <ExclamationCircleOutlined />
                        </span>
                      </Tooltip>
                    </>
                  ) : (
                    opportunity_Id
                  )}
                </p>
              </Card.Grid>
              {isProposalCreated && (
                <Card.Grid hoverable={false} className="grid-style Appoinment-Heading">
                  <p className="text-type">Proposal Number</p>
                  <p className="text-content capitalize" style={{ width: "100px" }}>
                    {leadPolicyId}
                  </p>
                </Card.Grid>
              )}
            </div>
          </div>
        </div>
        {/* {leadsData?.globalTab === "team" || leadStatus === "Converted" ? (
          ""
        ) : ( */}
        <button className="update-btn" onClick={() => updateHandler(id)}>
          Update
        </button>
        {/* )} */}
      </Card>
    </div>
  );
  //Card for Mobile
  if (width < breakpoint) {
    card = (
      <Card className="lead-card-mobile" hoverable>
        {allocateBtnStatus && (
          <input
            style={{
              marginTop: "-4.5rem",
              marginLeft: "-1rem",
            }}
            id="checkbox"
            type="checkbox"
            checked={chkID && checkedLead.length && checkedLead?.filter((a) => a.id.includes(chkID))}
            onChange={(e) => checkboxes(props, e)}
          ></input>
        )}
        <div
          style={{ width: "100%" }}
          onClick={() => updateHandler(id)}
          role="button"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              // Checks if Enter key is pressed
              updateHandler(id);
            }
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", width: "100%" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                flex: 1,
                paddingRight: "10px",
              }}
            >
              <Avatar
                className="avatar-mobile"
                size={{
                  xs: 50,
                  md: 40,
                  xl: 50,
                }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#C6C7C9",
                  minWidth: "50px",
                }}
              >
                {nameShorter(leadName)}
              </Avatar>

              <div className="card-content-text capitalize">
                <p className="user-name-text">
                  {leadName}
                  <span className="user-id user-name-text uppercase m-3">{lead_Id}</span>
                </p>
                {leadComponent}
              </div>
            </div>

            <div className="otp-data" style={{ display: "flex", flexWrap: "wrap", justifyContent: "flex-end", maxWidth: "45%", gap: "5px" }}>
              <p className="capitalize bussiness" style={{ margin: 0, width: "auto", padding: "4px 8px" }}>{leadType}</p>
              {sourceOfLead === "DSO" ? (
                <p className="capitalize bussiness-lsq" style={{ margin: 0, width: "auto", padding: "4px 8px" }}>{sourceOfLead}</p>
              ) : lsq === "LSQ" ? (
                <p className="capitalize bussiness-lsq" style={{ margin: 0, width: "auto", padding: "4px 8px" }}>{lsq}</p>
              ) : lsq ? (
                <p className="capitalize bussiness-lsq" style={{ margin: 0, width: "auto", padding: "4px 8px" }}>{lsq}</p>
              ) : null}
            </div>
          </div>

          <hr
            style={{
              margin: "10px 0",
              opacity: "0.5",
              color: "lightgray",
            }}
          />

          <div className="content-body Datainfo-Main-Container">
            <div className="Dateinfo-Container Dateinfo-Container-baseline">
              <Card.Grid hoverable={false} className="grid-style">
                <p className="text-type">Created on</p>
                <p className="text-content">{created_date}</p>
              </Card.Grid>
              <Card.Grid hoverable={false} className="grid-style AllocatedBy-Heading">
                <p className="text-type">Allocated on</p>
                <p className="text-content">{allocatedDate}</p>
              </Card.Grid>
              <Card.Grid hoverable={false} className="grid-style Appoinment-Heading">
                <p className="text-type">Appointment on</p>
                <p className="text-content">{appointmentOn}</p>
              </Card.Grid>
              <Card.Grid hoverable={false} className="grid-style">
                <p className="text-type">Mobile No.</p>
                <p className="text-content">{primaryMobile}</p>
              </Card.Grid>
              <Card.Grid hoverable={false} className="grid-style AllocatedBy-Heading">
                <p className="text-type">Allocated by</p>
                <p className="text-content capitalize" style={{ width: "100px" }}>
                  {allocatedBy}
                </p>
              </Card.Grid>
              <Card.Grid hoverable={false} className="grid-style Appoinment-Heading">
                <p className="text-type">Allocated to</p>
                <p className="text-content capitalize" style={{ width: "100px" }}>
                  {allocatedTo}
                </p>
              </Card.Grid>
              <Card.Grid hoverable={false} className="grid-style Appoinment-Heading">
                <p className="text-type">Opportunity Id</p>
                <p className="text-content capitalize" style={{ width: "100px" }}>
                  {opportunity_Id && opportunity_Id !== "-" ? (
                    <>
                      <Tooltip title={`${opportunity_Id}`}
                      >
                        <span>
                          ...{opportunity_Id.slice(-5)} <ExclamationCircleOutlined />
                        </span>
                      </Tooltip>
                    </>
                  ) : (
                    opportunity_Id
                  )}
                </p>
              </Card.Grid>
              {isProposalCreated && (
                <Card.Grid hoverable={false} className="grid-style Appoinment-Heading">
                  <p className="text-type">Proposal Number</p>
                  <p className="text-content capitalize" style={{ width: "100px" }}>
                    {leadPolicyId}
                  </p>
                </Card.Grid>
              )}
            </div>
          </div>
        </div>

        <button className="update-btn-mobile" onClick={() => updateHandler(id)}>
          Update
        </button>
        {/* <MoreOutlined
          style={{ fontSize: "25px", marginLeft: "auto", color: "grey" }}
        /> */}
      </Card>
    );
  }
  return <div key={id}>{card}</div>;
});

export default LeadCard;
